import * as d3 from 'd3';
import { LabelFormat } from './LabelFormat';

export function renderLabels(selection: d3.selection.Update<{ labels: LabelFormat[] }>) {
    const dataBound = selection.selectAll('.label')
        .data(d => d.labels);
    dataBound
        .exit()
        .remove();
    const enterSelection = dataBound
        .enter()
        .append('g')
        .classed('label', true);
    enterSelection.append('text')
        .classed('tickLabel', true)
        .classed('fixed-size', true)
        ;
    dataBound
        // .transition()
        .attr('transform', (d, i) => `translate(${d.position.x},${d.position.y})`)
        .select('text')
        .style('text-anchor', d => d.anchor)
        .text(d => d.formatted)
        .style('font-size', d => d.fontSize + 'px');
}